import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { cameraService } from "../../../services/cameraService";
import CameraNew from "./CameraNew";
import Loading from "../../../components/Loading/Loading";

function CameraEdit() {

  const { id } = useParams();
  const [formData, setFormData] = useState();

  useEffect(() => {
    if (id) {
      cameraService.find(+id).then((cameraDetails) => {
        setFormData({
          id: cameraDetails.id,
          name: cameraDetails.nome,
          brand: cameraDetails.marca,
          model: cameraDetails.modelo,
          installationDate: cameraDetails.data_instalacao,
          observations: cameraDetails.observacoes,
          locations: cameraDetails.locais?.map((local) => {
            return { label: local.nome, id: local.id }
          }),
          referencePoints: cameraDetails.pontos_referencia?.map((ponto) => {
            return { label: ponto.nome, id: ponto.id }
          })
        })
      })
    }

  },[id])

  return (
      <>
        {formData ? (<CameraNew data={formData}></CameraNew>) : <Loading/>}
      </>
  );
}

export default CameraEdit;
